export default "__VITE_ASSET__kD0BVPP6__"